import React, { useEffect, useRef } from "react";
import {SectionBackgroundImageSubMenu} from "../Section/SectionBackgroundImageSubMenu";
import {SectionHeightSubMenu} from "../Section/SectionHeightSubMenu";
import {BackgroundColorSubMenu} from "../Section/BackgroundColorSubMenu";
import {VerticalAlignMenu} from "../Section/VerticalAlignMenu";
import {SectionAudioSubMenu} from "../AudioGuide/SectionAudioSubMenu";
import {MapConfigSubMenu} from "../map/MapConfigSubMenu";
import {TemplatePresetSubMenu} from "../Section/TemplatePresetSubMenu";

export const SubMenu = ({
    section,
    sectionId,
    currentMenu,
    onCloseMenu,
    onUpdateTrack,
    onMediaSelect,
    onUpdateMapConfig,
}) => {
    const menuWrapperRef = useRef(null);

    useEffect(() => {
        if (currentMenu !== "mapMenu" && currentMenu !== "audioMenu") return;
        const handleClickOutside = (event) => {
            const target = event.target instanceof Element ? event.target : event.target?.parentElement;
            if (
                menuWrapperRef.current &&
                !menuWrapperRef.current.contains(target) &&
                !target?.closest?.(".MuiPopover-root, .MuiMenu-root, .MuiDialog-root, .MuiAutocomplete-popper")
            ) {
                if (target?.closest?.("button")?.closest?.("[class*='editSectionMenu']")) {
                    return;
                }
                if (onCloseMenu) onCloseMenu();
            }
        };
        document.addEventListener("mousedown", handleClickOutside, true);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside, true);
        };
    }, [currentMenu, onCloseMenu]);

    switch (currentMenu) {
        case "mapMenu":
            return (
                <div ref={menuWrapperRef} style={{ position: "absolute", top: "45px", left: 0, zIndex: 1200 }}>
                    <MapConfigSubMenu
                        mapConfig={section?.mapConfig || section}
                        onUpdate={onUpdateMapConfig}
                        onClose={onCloseMenu}
                    />
                </div>
            );
        case "audioMenu":
            return (
                <div ref={menuWrapperRef} style={{ position: "absolute", top: "45px", left: 0, zIndex: 1200 }}>
                    <SectionAudioSubMenu
                        audioTrack={section?.audioTrack || {}}
                        onUpdate={onUpdateTrack}
                        onMediaSelect={onMediaSelect}
                        onClose={onCloseMenu}
                    />
                </div>
            );
        case "wallpaperMenu":
            return (
                <SectionBackgroundImageSubMenu
                    section={section}
                    sectionId={sectionId}
                    onClose={onCloseMenu}
                />
            )
        case "heightMenu":
            return (
                <SectionHeightSubMenu
                    section={section}
                    sectionId={sectionId}
                    onClose={onCloseMenu}
                />
            )
        case "colorMenu":
            return (
                <BackgroundColorSubMenu
                    section={section}
                    sectionId={sectionId}
                    onClose={onCloseMenu}
                />
            )
        case "verticalAlignMenu":
            return (
                <VerticalAlignMenu
                    sectionId={sectionId}
                    onClose={onCloseMenu} />
            )
        case "presetMenu":
            return (
                <TemplatePresetSubMenu
                    section={section}
                    sectionId={sectionId}
                    onClose={onCloseMenu}
                />
            );
        default:
            return null
    }
}